import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { shallowEqual } from 'react-redux';
import { useAppSelector } from '../../redux/store';
import { isTestEnvironment } from '../../utils/utils';
import { AutoSizingTextActiveTimerBar } from './pixiComponents/autoSizingTextActiveTimerBar';
const TEXT = 'Side Bet Phase';
export const SideBetPhaseDisplayContainer = () => {
    const sideBetPhaseProperties = useAppSelector((state) => state.poker.sideBetPhaseProperties, shallowEqual);
    const sideBetPhaseMessageCoords = useAppSelector((state) => state.gameDimensions.sideBetPhaseMessageCoords, shallowEqual);
    if (!sideBetPhaseProperties || !sideBetPhaseMessageCoords) {
        return null;
    }
    const { startTimestampMs, durationMs } = sideBetPhaseProperties;
    const timerBarPixiData = isTestEnvironment() ? { type: 'side-bet-phase-timer-bar' } : null;
    return (_jsx(Container, { interactiveChildren: false, children: _jsx(AutoSizingTextActiveTimerBar, { x: sideBetPhaseMessageCoords.x, y: sideBetPhaseMessageCoords.y, startTimestampMs: startTimestampMs, totalMs: durationMs, text: TEXT, timerBarPixiData: timerBarPixiData, textPixiDataType: 'side-bet-phase-message' }) }));
};
